import React from 'react';

import { withResetReport } from '../../../shared/containers/containerResetReport'

import ButtonIconWrapper from '../../../shared/items/contols/buttonIconWrapper'
import TooltipWrapper from '../../../shared/items/contols/tooltipWrapper'

const ResetReportButton = props => {
  const { onResetReport } = props

  return (
    <TooltipWrapper title='Сбросить' position='top'>
      <div>
        <ButtonIconWrapper type='secondary' icon='delete' handleClick={onResetReport.bind(this)} />
      </div>
    </TooltipWrapper>
  )
}

export default withResetReport(React.memo(ResetReportButton))